import { render, staticRenderFns } from "./edit-index.vue?vue&type=template&id=81a3b90c&scoped=true&"
import script from "./edit-index.vue?vue&type=script&lang=js&"
export * from "./edit-index.vue?vue&type=script&lang=js&"
import style0 from "./edit-index.vue?vue&type=style&index=0&id=81a3b90c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a3b90c",
  null
  
)

export default component.exports